export default {
  title: '码头管理',

  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '码头名称、代码',
    port: '所属港口',
    portPlaceholder: '选择港口',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  actions: {
    addTerminal: '新增码头',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    edit: '编辑',
    enable: '启用',
    disable: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  table: {
    terminalName: '码头名称（中文）',
    terminalNameEn: '码头名称（英文）',
    terminalCode: '码头代码',
    terminalLink: '码头链接',
    port: '港口',
    operator: '运营商',
    capacity: '处理能力',
    status: '状态',
    operation: '操作'
  },

  form: {
    addTitle: '新增码头',
    editTitle: '编辑码头',
    terminalName: '码头名称',
    terminalCode: '码头代码',
    port: '所属港口',
    operator: '运营商',
    capacity: '处理能力',
    status: '状态'
  },

  modal: {
    title: '选择码头',
    confirmText: '确认添加 ({count})',
    selected: '已选择 {count} 个码头，共 {total} 个'
  },

  confirm: {
    enableItem: '确定要启用此码头吗？',
    disableItem: '确定要禁用此码头吗？'
  },

  messages: {
    selectToAdd: '请选择要添加的码头',
    selectToEnable: '请选择要启用的码头',
    selectToDisable: '请选择要禁用的码头',
    loadError: '码头数据加载失败，请稍后重试',
    searchError: '码头搜索失败，请稍后重试',
    platformLoadError: '平台码头数据加载失败，请稍后重试',
    associateSuccess: '成功关联 {count} 个码头',
    associateError: '关联失败，请稍后重试',
    statusToggleSuccess: '码头已{status}',
    statusToggleError: '状态切换失败，请稍后重试',
    batchEnableSuccess: '已启用 {count} 个码头',
    batchEnableError: '批量启用失败，请稍后重试',
    batchDisableSuccess: '已禁用 {count} 个码头',
    batchDisableError: '批量禁用失败，请稍后重试'
  },

  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  ports: {
    shanghai: '上海港',
    shenzhen: '深圳港',
    ningbo: '宁波港',
    qingdao: '青岛港',
    tianjin: '天津港',
    guangzhou: '广州港',
    losangeles: '洛杉矶港',
    newyork: '纽约港',
    rotterdam: '鹿特丹港',
    hamburg: '汉堡港',
    singapore: '新加坡港',
    hongkong: '香港港'
  }
}